<template>
  <html>
    <head> </head>
    <body>
      <div class="contai">
        <div class="container-fluid" :id="id">
          <div class="row" >
            <!--img
              id="header-s"
              src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/Loyalty-hub-header-s.png"
            /-->
            <div>
            <div class="fixheadd">
              <h1 class="fixhead">ข้อตกลงและเงื่อนไขการใช้งาน</h1>
            </div>
            </div>
          </div>
        </div>

        <div class="imfor" v-html="content.detail" style="padding: 0.5em">
          <!-- <ol>
            <li>
              ซื้อผลิตภัณฑ์เครื่องดื่มชูกำลัง ( ผสมคาเฟอีน ) คาราบาวแดง
              และผลิตภัณฑ์เครื่องดื่มคาราบาวแดง กลิ่นกรีนแอปเปิ้ล
            </li>
            <li>
              ผู้ร่วมกิจกรรมจะต้องสมัครสมาชิกเพื่อนบาวแดงด้วยการเพิ่ม Official Account
              คาราบาวแดง (@Carabao) เป็นเพื่อนในแอปพลิเคชั่นไลน์ (Line)
              ด้วยการลงทะเบียนสมาชิก ระบุ ชื่อ - นามสกุล ปเบอร์โทรศัพท์ เพศ ปีที่เกิด
            </li>
            <li>
              จากนั้นใส่รหัสสินค้าที่อยู่ใต้ฝาหรือใต้ห่วงกระป๋องผลิตภัณฑ์
              หลังจากส่งรหัสแล้วระบบจะแสดง ข้อความขอบคุณโดยผู้ส่งรหัสเข้าร่วมชิงโชคไม่ต้อง
              เสียค่าบริการใดๆทั้งสิ้น การส่งรหัส 1 ครั้ง / หมายเลขรหัสสินค้า ถือเป็น 1
              สิทธิ์
            </li>
            <li>
              พิเศษสำหรับสมาชิกเพื่อนบาวแดงส่งรหัสใต้ฝาคาราบาวแดงหรือใ
              sต้ห่วงคาราบาวกรีนแอปเปิ้ลครั้งแรกของการร่วมกิจกรรม ตั้งแต่ วันที่ 29
              ธันวาคม พ.ศ. 2563 ถึงวันที่ 31 ธันวาคม พ.ศ. 2564 จะได้รับ 1 สิทธิ์แลกซื้อ
            </li>
          </ol> -->
        </div>
        <div style="margin-bottom: 200px"></div>

        <nav class="navbar navbar-expand-lg navbar-light bg-light fixed-bottom">
          <div class="checkbok" style="margin-bottom: 1px">
            <label class="container" style="padding-bottom: 8px; padding-left: 50px"
              >ตกลงและยอมรับเงื่อนไข
              <input
                type="checkbox"
                class="checkbox"
                v-model="term_acception"
                @click="!term_acception"
              />
              <span class="checkmark"></span>
            </label>
          </div>
          <div
            class="container-fluid"
            style="
              margin-top: 5px;
              margin-bottom: 5px;
              margin-left: 5px;
              margin-right: 5px;
              width: 1000px;
            "
          >
            <!--button
              type="button"
              class="btn btn-secondary"
              style="
                color: #ffffff;
                background-color: #8c8c8c;
                width: 167px;
                height: 35px;
                center: 20px;
              "
            >
              ไม่ยินยอม
            </button-->
            <button
              :disabled="!term_acception"
              @click="acceptClick"
              type="button"
              class="btn light-color font-color"
              style="
                

                width: 100%;
                height: 35px;
                margin-left: 0px;
              "
            >
              ยอมรับ
            </button>
          </div>
        </nav>
      </div>
    </body>
  </html>
</template>
<script>
export default {
  name: "Register01",

  data() {
    return {
      term_acception: false,
      contentCode: "Terms"
    };
  },
  computed: {
    content() {
      let contents =  this.$store.state.contents.filter((item) => {
        console.log('------------- filter contents --------------');
        console.log(item);
        console.log(this.contentCode);
        console.log('---------------------------------------------');
        return item.code == this.contentCode ;
      })[0] || {detail: ""};
      console.log(contents);
      return contents;
    },
    id(){
        return new Date().getTime().toString();
      }
  },
  beforeMount() {},
  mounted() {
    console.log("REGISTER  PAGE");
    //alert(localStorage.getItem("apiKey"));
    if (this.$store.state.logged) {
      this.$store.dispatch("setLogged", false);
    }
  },

  methods: {
    acceptClick() {
      //console.log("accept");
      if (this.term_acception) {
        this.$router.push({
          name: "Register02",
          /*query: {
            apiKey: localStorage.getItem("apiKey"),
            custId: localStorage.getItem("custId"),
          },*/
        });
      } else {
        alert("กรุณายอมรับเงื่อนไข");
      }
    },
  },
};
</script>
<style scoped>
@import "./Css/style.css";
.fixhead {
    margin-left: 20px !important;
    text-align: center !important;
    padding-left: 20px !important;
}
.fixheadd {
margin-left: -45px !important;
}

.contai {
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  background-color: rgb(0, 56, 39) !important;border-radius: 0px 0px 30px 30px;
}
@media (min-width: 768px) {
  .contai {
    width: 750px;
  }
}
@media (min-width: 992px) {
  .contai {
    width: 970px;
  }
}
@media (min-width: 1200px) {
  .contai {
    width: 1170px;
  }
}
.text-center {
  text-align: left !important;
  margin-left: -45px;
}
.container {
  position: relative;
  cursor: pointer;
  font-size: 17px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.checkbok {
  padding-top: 5px;
  padding-right: 0px;
  padding-left: 8px;
}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  margin-right: 50px;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 8px;
  height: 28px;
  width: 28px;
  background-color: #eee;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: #f7f7f7;
  border: 2px solid #7bc79a;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 9px;
  top: 1px;
  width: 9px;
  height: 18px;
  border: solid #7bc79a;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.imfor {
  top: 0px;
  position: relative;
  overflow: visible;
  padding-top: 30px !important;
  color: #8c8c8c;
  background-color: #ffffff;
  width: 300;
  height: auto;
  margin-top: 9px;
  margin-bottom: 5px;
  margin-right: 0px;
  margin-left: 0px;
  font-size: 17px;
  padding-bottom: 100px;
}

.imfor.p{
  text-align:center;
}

h1 {
  color: rgb(255, 255, 255);
  font-size: 22px;
}
</style>
